import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import api from '../../utils/api';

function fmt(n) { return '₹' + Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 }); }

export default function PayslipsPage() {
  const [year, setYear] = useState(new Date().getFullYear());

  const { data: payslips = [], isLoading } = useQuery({
    queryKey: ['my-payslips', year],
    queryFn: () => api.get('/hr/payroll').then(r =>
      r.data.filter(p => p.month?.startsWith(String(year)))
    ),
  });

  function openPayslip(id) {
    api.get(`/hr/payroll/${id}/payslip`, { responseType: 'text' }).then(r => {
      const blob = new Blob([r.data], { type: 'text/html' });
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');
    }).catch(() => toast.error('Failed to load payslip'));
  }

  if (isLoading) return <div className="loading-screen"><div className="spinner" /></div>;

  return (
    <div>
      <div className="section-head">
        <h2>My Payslips</h2>
        <select value={year} onChange={e => setYear(Number(e.target.value))} style={{ width: 100 }}>
          {[2024, 2025, 2026, 2027].map(y => <option key={y} value={y}>{y}</option>)}
        </select>
      </div>

      {payslips.length === 0 ? (
        <div className="empty card">No payslips available for {year}.</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {payslips.map(p => {
            const monthLabel = new Date(p.month + '-01').toLocaleString('default', { month: 'long', year: 'numeric' });
            return (
              <div key={p.id} className="card" style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                <div style={{ background: 'var(--accent)', color: '#fff', borderRadius: 8, padding: '10px 14px', textAlign: 'center', minWidth: 64 }}>
                  <div style={{ fontSize: 11, opacity: .75, textTransform: 'uppercase' }}>{new Date(p.month + '-01').toLocaleString('default', { month: 'short' })}</div>
                  <div style={{ fontWeight: 800, fontSize: 18 }}>{p.month?.slice(0, 4)}</div>
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 600, fontSize: 14 }}>{monthLabel}</div>
                  <div style={{ fontSize: 12, color: 'var(--text2)', marginTop: 2 }}>
                    Present: {Number(p.present_days)} days
                    {Number(p.paid_leave_days) > 0 && ` · Paid leave: ${Number(p.paid_leave_days)} days`}
                    {Number(p.absent_days) > 0 && <span style={{ color: 'var(--red)' }}> · Absent: {Number(p.absent_days)} days</span>}
                  </div>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ fontSize: 12, color: 'var(--text2)' }}>Gross: {fmt(p.gross_salary)}</div>
                  <div style={{ fontSize: 16, fontWeight: 800, color: 'var(--accent)' }}>{fmt(p.net_salary)}</div>
                  <div style={{ fontSize: 10, color: 'var(--text3)' }}>Net Pay</div>
                </div>
                <button className="btn-primary btn-sm" onClick={() => openPayslip(p.id)}>
                  ⬇ Download
                </button>
              </div>
            );
          })}
        </div>
      )}

      <div style={{ marginTop: 20 }}>
        <div className="card" style={{ background: 'var(--accent-light)' }}>
          <div style={{ fontSize: 12, color: 'var(--accent)' }}>
            Click "Download" to open your payslip in a new tab. Use Ctrl+P (or Cmd+P on Mac) and select "Save as PDF" to save it.
          </div>
        </div>
      </div>
    </div>
  );
}
